import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionContext, Button, Card, useAccordionButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFormContext, useFieldArray } from 'react-hook-form';
import Flex from 'components/common/Flex';
import classNames from 'classnames';
import ArticlePropertyForm from './ArticlePropertyForm';

const properties = [{ name: '', color: '', images: [] }];

const CustomToggle = ({ eventKey, className }) => {
 const { activeEventKey } = useContext(AccordionContext);
 const decoratedOnClick = useAccordionButton(eventKey);

 const isCurrentEventKey = activeEventKey === eventKey;
 return (
  <Button
   variant="falcon-primary"
   type="button"
   className={classNames('p-0 icon-item icon-item-sm', { [className]: className })}
   onClick={decoratedOnClick}
  >
   <FontAwesomeIcon icon={isCurrentEventKey ? 'chevron-up' : 'chevron-down'} />
  </Button>
 );
};

const ArticleReferences = () => {
 const { control, watch } = useFormContext();
 const { fields, append, remove } = useFieldArray({ control, name: 'references' });

 useEffect(() => {
  const references = watch('references_name') ?? [];
  remove(
   fields.reduce((a, e, i) => {
    if (!references?.some(a => a === e?.reference)) a.push(i);
    return a;
   }, [])
  );
  references.forEach(e => !fields.some(a => e === a?.reference) && append({ reference: e, properties }));
  //   console.log({ references, fields }, watch());
 }, [watch('references_name')]);

 return fields.length ? (
  <Accordion defaultActiveKey="0" className="g-3 mt-3">
   {fields.map(({ reference }, index) => (
    <Card key={'ref_' + index} className="mt-2 overflow-hidden">
     <Card.Header className="bg-body-tertiary">
      <Flex justifyContent="start" alignItems="center" wrap="wrap">
       <div className="flex-grow-1 text-truncate">
        <h6 className="mb-0 text-capitalize">{reference}</h6>
        <small className="m-0 text-muted fs--2">Referencia</small>
       </div>
       <div className="ps-3 border-start border-start-2">
        <CustomToggle eventKey={index} className="" />
       </div>
      </Flex>
     </Card.Header>
     <Accordion.Collapse eventKey={index}>
      <Card.Body className="">
       <ArticlePropertyForm index={index} />
      </Card.Body>
     </Accordion.Collapse>
    </Card>
   ))}
  </Accordion>
 ) : (
  <></>
 );
};

CustomToggle.propTypes = {
 eventKey: PropTypes.number.isRequired,
 className: PropTypes.string
};

export default ArticleReferences;
